import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDSnp520gG-jclwg1IIjLjF3ImOmCqZzqQ",
  authDomain: "cities-appliance-8b13f.firebaseapp.com",
  projectId: "cities-appliance-8b13f",
  storageBucket: "cities-appliance-8b13f.appspot.com",
  messagingSenderId: "1059112010794",
  appId: "1:1059112010794:web:bef868b20c2ee0a6116f53",
  measurementId: "G-7FSTYK7185"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
// Get a non-default Storage bucket
const storage = firebase.app().storage("gs://my-custom-bucket");

export { db, auth, provider, storage };
export default db;
